import React from 'react'
import CareersCard from './CareersCard';

const Careers = () => {
  return (
    <>
        <div className="project-section container-fluid">
                <h1 className="section-heading">#Employment</h1>
                <div className="careersSection">
                    <CareersCard/>
                </div>
            </div>
    </>
  )
}

export default Careers;